import { render, staticRenderFns } from "./SiteInfoPopup.vue?vue&type=template&id=52e4aac2&"
import script from "./SiteInfoPopup.vue?vue&type=script&lang=js&"
export * from "./SiteInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports